import { fade, darken, lighten } from 'material-ui/utils/colorManipulator';
import spacing from 'material-ui/styles/spacing';

import {
  grey100, grey300, grey500,
  white, darkBlack, fullBlack,
} from 'material-ui/styles/colors';

const steelblue = '#3B53A7';
const indianred = '#cd5c5c';
const forestgreen = '#228B22';

export default {
  spacing,
  fontFamily: 'Open Sans, sans-serif',
  palette: {
    primary1Color: steelblue,
    primary2Color: darken(steelblue, 0.15),
    primary3Color: lighten(steelblue, 0.6),
    accent1Color: indianred,
    accent2Color: grey100,
    accent3Color: grey500,
    textColor: darkBlack,
    alternateTextColor: white, // darkBlack,
    secondaryTextColor: fade(darkBlack, 0.54), // darken(white, 0.05),
    canvasColor: white,
    borderColor: grey300,
    appBarColor: white,
    footerColor: white, // lighten(darkBlack, 0.9),
    disabledColor: fade(darkBlack, 0.3),
    pickerHeaderColor: steelblue,
    clockCircleColor: fade(darkBlack, 0.07),
    shadowColor: fullBlack,
    errorText: indianred,
    successText: lighten(forestgreen, 0.1),
  },
};



// WEBPACK FOOTER //
// ./src/themes/white.js